import { useEffect } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../auth/AuthContext'
import { KnowProfile } from '../pages/data/KnowProfile'
import { useTabletContext } from './TabletLayout'

/** The shared tablet owns incomplete demographics before the headset is used. */
export function TabletProfile() {
  const { phase, onProfileDone } = useTabletContext()
  const { user } = useAuth()
  const complete = user?.pending_profile_fields?.length === 0

  useEffect(() => {
    if (phase === 'profile' && complete) onProfileDone()
  }, [phase, complete, onProfileDone])

  if (phase !== 'profile') return <Navigate to="/tablet" replace />
  return <KnowProfile />
}
